var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade-in-up"}},[_c('v-container',{staticClass:"service-form-template custom-border-grey-dashed",class:{
      'pointer-events-none': !_vm.getPermission('service-form:update'),
    },attrs:{"fluid":"","id":"service-form"}},[_c(_vm.getComponent,{tag:"component",attrs:{"detail":_vm.detail,"serviceForm":_vm.serviceForm}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }